import * as d3 from 'd3';

type Arguments = {
  graph: d3.Selection<null, unknown, null, undefined>;
  data: Record<string, string | number>[];
  xScale: d3.ScaleBand<string | number>;
  yScale: d3.ScaleLinear<number, number, never>;
  bars: (string | number)[];
  width: number;
  colors: d3.ScaleOrdinal<string, unknown, never>;
  stackLabels: string[];
  graphId: string;
  setCoords?: (coords: [number, number] | null) => void;
  setTooltipData?: (data: any) => void;
};
export const appendStackedBarGraph = ({
  data,
  stackLabels,
  colors,
  yScale,
  xScale,
  bars,
  graph,
  width,
  graphId,
  setCoords,
  setTooltipData,
}: Arguments) => {
  let timer: NodeJS.Timeout | undefined;
  const stackedData = d3.stack().keys(stackLabels)(
    data as Record<string, number>[],
  );
  const onMouseOver = (event: MouseEvent, d: any) => {
    if (timer !== undefined) {
      clearTimeout(timer);
      timer = undefined;
    }
    d3.selectAll(`.${graphId}-bar`).style('opacity', '0.4');
    d3.selectAll(`.${graphId}-bar-${d.data.bar}`).style('opacity', '1');
    const x =
      (event.target as Element)?.getBoundingClientRect?.()?.left + width / 2;
    const y = (
      d3.select(`.${graphId}-bar-${d.data.bar}-top`)?.node() as Element
    )?.getBoundingClientRect?.()?.top;
    if (x && y) {
      setCoords?.([x, y]);
      setTooltipData?.(d.data);
    }
  };
  const onMouseOut = () => {
    timer = setTimeout(() => {
      d3.selectAll(`.${graphId}-bar`).style('opacity', '1');
    }, 20);
    setCoords?.(null);
  };
  graph
    .append('g')
    .selectAll('g')
    .data(stackedData)
    .enter()
    .append('g')
    .attr('fill', (d) => String(colors(d.key)))
    .selectAll('rect')
    .data((d) => d)
    .enter()
    .append('rect')
    .attr('y', (d) => yScale(d[1]))
    .attr('x', (_, i) => Number(xScale(String(bars[i]))))
    .attr('width', width)
    .attr('height', (d) => yScale(d[0]) - yScale(d[1]))
    .attr('class', (d) => {
      const classification = d.data.total === d[1] ? 'top' : 'bottom';
      return `${graphId}-bar ${graphId}-bar-${d.data.bar} ${graphId}-bar-${d.data.bar}-${classification}`;
    })
    .on('mouseover', onMouseOver)
    .on('mouseout', onMouseOut);
};
